import { Injectable } from '@angular/core';
import { NavigationExtras } from '@angular/router';

import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RouteService {
  public queryParamList$ = new BehaviorSubject<NavigationExtras>({
    queryParams: {},
  });
  public route$ = new BehaviorSubject<string>('');

  public getRoute(): Observable<string> {
    return this.route$.asObservable();
  }
  public setRoute(route: string): void {
    this.route$.next(route);
  }

  public resetRoute(): void {
    this.route$.next('');
  }
}
